import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "floor-area mt-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-6 col-lg-5 pe-4 align-content-center" }
const _hoisted_8 = { for: "floor-area-net form-label" }
const _hoisted_9 = { class: "col-6 col-lg-3" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6 col-lg-5 pe-4 align-content-center" }
const _hoisted_15 = { for: "floor-area-gross form-label" }
const _hoisted_16 = { class: "col-6 col-lg-3" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BuildingPartControl = _resolveComponent("BuildingPartControl")!
  const _component_StairsIcon = _resolveComponent("StairsIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasBuildingPartsSpecified())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingParts, (_, key) => {
            return (_openBlock(), _createBlock(_component_BuildingPartControl, {
              key: key,
              state: _ctx.buildingParts[key],
              roomLists: _ctx.roomLists,
              ref_for: true,
              ref: key,
              validate: _ctx.validate,
              onClone: ($event: any) => (_ctx.cloneBuildingPart(key)),
              onRemove: ($event: any) => (_ctx.removeBuildingPart(key))
            }, null, 8, ["state", "roomLists", "validate", "onClone", "onRemove"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addBuildingPart()))
          }, [
            _createVNode(_component_StairsIcon, { class: "input-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('form.floorArea.buttonAddBuildingPart')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('floorArea.netArea')), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              id: "floor-area-net",
              type: "text",
              disabled: _ctx.hasBuildingPartsSpecified(),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.netAreaRaw) = $event)),
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.isInvalid() && _ctx.netArea === null}])
            }, null, 10, _hoisted_11), [
              [_vModelText, _ctx.netAreaRaw]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "input-group-text" }, [
              _createTextVNode("m"),
              _createElementVNode("sup", null, "2")
            ], -1))
          ]),
          (_ctx.isInvalid() && ! _ctx.hasBuildingPartsSpecified())
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('form.errors.invalidFloorArea')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('floorArea.grossArea')), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              id: "floor-area-gross",
              type: "text",
              disabled: _ctx.hasBuildingPartsSpecified(),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.grossAreaRaw) = $event)),
              class: _normalizeClass([{'is-invalid': _ctx.isInvalid() && (_ctx.grossArea === null || _ctx.isGrossAreaTooLow())}, "form-control w-50"])
            }, null, 10, _hoisted_18), [
              [_vModelText, _ctx.grossAreaRaw]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "input-group-text" }, [
              _createTextVNode("m"),
              _createElementVNode("sup", null, "2")
            ], -1))
          ]),
          (_ctx.isInvalid() && ! _ctx.hasBuildingPartsSpecified())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.isGrossAreaTooLow())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('form.errors.grossAreaTooLow')), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}